import PropTypes from 'prop-types';
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
export default refType;


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/refType/refType.js
// module id = 1595
// module chunks = 22